import { render, staticRenderFns } from "./msSelect.vue?vue&type=template&id=f4f22b26&scoped=true"
import script from "./msSelect.vue?vue&type=script&lang=js"
export * from "./msSelect.vue?vue&type=script&lang=js"
import style0 from "./msSelect.vue?vue&type=style&index=0&id=f4f22b26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f22b26",
  null
  
)

export default component.exports